import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IConfirmWidgetComponentProps } from './ConfirmWidgetFormComponent.tsx';
import { ConfirmWidgetLayoutComponent } from './components/ConfirmWidgetLayoutComponent.tsx';

/**
 * Componente che gestisce l'anteprima di configurazione di un widget di tipo
 * `Confirm`.
 */
export function ConfirmWidgetPreviewComponent(
  props: IConfirmWidgetComponentProps,
) {
  const { widget } = props;
  const options = getWidgetProps(props);

  return <ConfirmWidgetLayoutComponent options={options} {...props} />;
}
